import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Create Proposal',
      type: 'details',
      watch: {
        '[]': [
          {
            '{}': {
              alias: 'save.proposal',
            },
          },
        ],
      },
      content: {
        '{}': {
          fields: {
            '[]': [
              {
                '{}': {
                  id: 'code',
                  meta: {
                    '{}': {
                      dmsAttr: {
                        '{}': {
                          attributeId: 'attr:ent#!proposals#!proposal:!code',
                        },
                      },
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'id',
                  meta: {
                    '{}': {
                      dmsAttr: {
                        '{}': {
                          attributeId: 'attr:ent#!proposals#!proposal:!id',
                        },
                      },
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'name',
                  meta: {
                    '{}': {
                      dmsAttr: {
                        '{}': {
                          attributeId: 'attr:ent#!proposals#!proposal:!name',
                        },
                      },
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'status',
                  meta: {
                    '{}': {
                      dmsAttr: {
                        '{}': {
                          attributeId: 'attr:ent#!proposals#!proposal:!status',
                        },
                      },
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'amount',
                  meta: {
                    '{}': {
                      dmsAttr: {
                        '{}': {
                          attributeId: 'attr:ent#!proposals#!proposal:!amount',
                        },
                      },
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'dueDate',
                  meta: {
                    '{}': {
                      dmsAttr: {
                        '{}': {
                          attributeId:
                            'attr:ent#!proposals#!proposal:!due_date',
                        },
                      },
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'client',
                  meta: {
                    '{}': {
                      dmsAttr: {
                        '{}': {
                          attributeId: 'attr:ent#!proposals#!proposal:!client',
                        },
                      },
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'orgOffering',
                  meta: {
                    '{}': {
                      dmsAttr: {
                        '{}': {
                          attributeId:
                            'attr:ent#!proposals#!proposal:!org_offering',
                        },
                      },
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'organization',
                  meta: {
                    '{}': {
                      dmsAttr: {
                        '{}': {
                          attributeId: 'attr:ent#!proposals#!proposal:!org',
                        },
                      },
                    },
                  },
                },
              },
            ],
          },
          onSave: {
            '{}': {
              action: {
                '{}': {
                  alias: 'save.proposal',
                },
              },
              variables: {
                '{}': {
                  proposalId: '${field:id}',
                  proposalCode: '${field:code}',
                  proposalName: '${field:name}',
                  proposalAmount: '${field:amount}',
                  proposalClient: '${field:client}',
                  proposalStatus: '${field:status}',
                  proposalDueDate: '${field:dueDate}',
                  proposalOrgOffering: '${field:orgOffering}',
                  proposalOrganization: '${field:organization}',
                },
              },
            },
          },
        },
      },
    },
  },
}
